import { TwScope } from "./TwScope";

// Full-screen loading indicator used while the session is being restored.
export const PageLoader = () => (
  <TwScope className="tw-flex tw-min-h-screen tw-items-center tw-justify-center">
    <div
      role="status"
      aria-label="Loading"
      className="tw-h-8 tw-w-8 tw-animate-spin tw-rounded-full tw-border-2 tw-border-primary tw-border-t-transparent"
    />
  </TwScope>
);
